import { ADMIN_ROUTE } from '@rfc/rfc-components-library/router'
import { ERouteId } from '../types/enum/RouteIdEnum'

export const CUSTOMERS_ROUTE = '/customers'
export const CUSTOMERS_ROUTES = {
    baseUrl: CUSTOMERS_ROUTE,
    detailUrl: `${CUSTOMERS_ROUTE}/:${ERouteId.CUSTOMERS_ID}`,
    buildUrl: (customerId: number) => `${CUSTOMERS_ROUTE}/${customerId}`
}

export const DETECTION_ROUTE = '/detections'
export const DETECTION_ROUTES = {
    baseUrl: DETECTION_ROUTE
}

export const ORDERS_ROUTE = '/orders'
export const ORDERS_ROUTES = {
    baseUrl: ORDERS_ROUTE,
    detailUrl: `${ORDERS_ROUTE}/:${ERouteId.ORDERS_ID}`,
    buildUrl: (orderId: number) => `${ORDERS_ROUTE}/${orderId}`
}

export const PRODUCTS_ROUTE = '/products'
export const PRODUCTS_ROUTES = {
    baseUrl: PRODUCTS_ROUTE,
    detailUrl: `${PRODUCTS_ROUTE}/:${ERouteId.PRODUCTS_ID}`,
    buildUrl: (productId: number) => `${PRODUCTS_ROUTE}/${productId}`
}

export const PRODUCTION_LINE_ROUTE = '/production-lines'
export const PRODUCTION_LINE_ROUTES = {
    baseUrl: PRODUCTION_LINE_ROUTE,
    detailUrl: `${PRODUCTION_LINE_ROUTE}/:${ERouteId.PRODUCTION_LINE_ID}`,
    buildUrl: (productionLineId: number) => `${PRODUCTION_LINE_ROUTE}/${productionLineId}`
}

export const ADMIN_ORDERS_ROUTE = `${ADMIN_ROUTE}/orders`
export const ADMIN_ORDERS_ROUTES = {
    baseUrl: ADMIN_ORDERS_ROUTE,
    detailUrl: `${ADMIN_ORDERS_ROUTE}/:${ERouteId.ORDERS_ID}`,
    buildUrl: (orderId: number) => `${ADMIN_ORDERS_ROUTE}/${orderId}`
}

export const ADMIN_TEMPLATES_ROUTE = `${ADMIN_ROUTE}/templates`
export const ADMIN_TEMPLATES_ROUTES = {
    baseUrl: ADMIN_TEMPLATES_ROUTE
}

export const ADMIN_CUSTOMERS_ROUTE = `${ADMIN_ROUTE}/customers`
export const ADMIN_CUSTOMERS_ROUTES = {
    baseUrl: ADMIN_CUSTOMERS_ROUTE,
    detailUrl: `${ADMIN_CUSTOMERS_ROUTE}/:${ERouteId.CUSTOMERS_ID}`,
    buildUrl: (customerId: number) => `${ADMIN_CUSTOMERS_ROUTE}/${customerId}`
}

export const ADMIN_PRODUCTS_ROUTE = `${ADMIN_ROUTE}/products`
export const ADMIN_PRODUCTS_ROUTES = {
    baseUrl: ADMIN_PRODUCTS_ROUTE,
    detailUrl: `${ADMIN_PRODUCTS_ROUTE}/:${ERouteId.PRODUCTS_ID}`,
    buildUrl: (productId: number) => `${ADMIN_PRODUCTS_ROUTE}/${productId}`
}

export const ADMIN_PRODUCTION_LINE_ROUTE = `${ADMIN_ROUTE}/production-lines`
export const ADMIN_PRODUCTION_LINE_ROUTES = {
    baseUrl: ADMIN_PRODUCTION_LINE_ROUTE,
    detailUrl: `${ADMIN_PRODUCTS_ROUTE}/:${ERouteId.PRODUCTION_LINE_ID}`,
    buildUrl: (productId: number) => `${ADMIN_PRODUCTS_ROUTE}/${productId}`
}
